import { useState } from "react";


export default function CityModal({
  isOpen,
  onClose,
  selectedCity,
  setSelectedCity,
}) {

  if (!isOpen) return null;
  

  const cities = [
  "Bhubaneswar",
  "Cuttack",
  "Puri",
  "Rourkela",
  "Sambalpur",
  "Berhampur",
  "Balasore",
  "Bhadrak",
  "Baripada",
  "Jharsuguda",
  "Jeypore",
  "Angul",
  "Dhenkanal",
  "Keonjhar",
  "Rayagada",
  "Paradeep",
];

  return (
    <div className="fixed inset-0 font-poppins bg-black/40 flex items-center justify-center z-50">

      {/* Modal Box */}
      <div className="bg-white w-[90%] max-w-[750px] rounded-xl p-[20px] relative">

        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-[12px] right-[12px] text-gray-500 text-[18px]"
        >
          ✕
        </button>

        <h2 className="text-center text-[24px] font-semibold mb-[20px]">
          Change City
        </h2>

        {/* Cities */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-[12px]">
          {cities.map((city) => (
            <div
              key={city}
              onClick={() => {
                setSelectedCity(city);
                onClose();
              }}
              className={`cursor-pointer px-[12px] py-[10px] rounded-lg text-center transition border
                ${
                  selectedCity === city
                    ? "bg-[#e6dff1] border-[#6c4ccf] text-[#6c4ccf]"
                    : "bg-[#f5f5f5] hover:bg-[#eee]"
                }
              `}
            >
              {city}

            </div>
          ))}
        </div>
        
      </div>
      
    </div>
  );
  
}